"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var inversify_react_1 = require("inversify-react");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var VariableStore_1 = __importDefault(require("QuoteV2/Stores/VariableStore"));
var react_1 = __importDefault(require("react"));
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var QuoteCurrencyFormatter_1 = __importDefault(require("Utils/QuoteCurrencyFormatter"));
var variablesCombobox = (0, BemBuilder_1.default)("variables-combobox");
var VariablesCombobox = (function (_super) {
    __extends(VariablesCombobox, _super);
    function VariablesCombobox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(VariablesCombobox.prototype, "currentlySelectedName", {
        get: function () {
            var selectedVariable = this.variableStore.getVariable(this.props.value);
            if (selectedVariable) {
                return selectedVariable.name;
            }
            else {
                return "";
            }
        },
        enumerable: false,
        configurable: true
    });
    VariablesCombobox.prototype.render = function () {
        var _this = this;
        var _a = this.props, onChange = _a.onChange, inputSize = _a.size, inputVariant = _a.variant, inputLabelHidden = _a.labelHidden;
        return (react_1.default.createElement(kaleidoscope_1.Combobox, { className: variablesCombobox(), label: "Variable Item", placeholder: "Find a variable", startingSearchTerm: this.currentlySelectedName, onSelect: function (selectedVariable) {
                onChange(selectedVariable.value);
            }, renderEntry: function (entry) {
                return (react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: variablesCombobox("variable-name") }, entry.data.name),
                    react_1.default.createElement("div", { className: variablesCombobox("variable-amount") }, "".concat(_this.quoteCurrencyFormatter.formatWithUserDecimalPreference(entry.data.defaultAmount, {
                        round: false,
                    }), " / ").concat(entry.data.unitName))));
            }, entries: this.variableStore.getAllVariables().map(function (variable) {
                return { label: variable.name, value: variable.getId(), data: variable };
            }), startElement: null, noResultsMessage: "No variables found", noEntriesMessage: react_1.default.createElement(kaleidoscope_1.Alert, { heading: "", alertType: kaleidoscope_1.AlertType.Info, alignment: kaleidoscope_1.AlertAlignment.Center }, "Create variable line items to set a varying item cost based on quantity."), listEndElement: react_1.default.createElement("div", { className: variablesCombobox("manage-button") },
                react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Secondary, width: "full", onClick: function () { return _this.variableEditor.show(_this.quoteCurrencyFormatter.getSymbol()); } }, "Manage variables")), renderInput: function (_a) {
                var _b;
                var onChange = _a.onChange, onBlur = _a.onBlur, onFocus = _a.onFocus, rest = __rest(_a, ["onChange", "onBlur", "onFocus"]);
                return (react_1.default.createElement(kaleidoscope_1.TextInput, __assign({}, rest, { label: "Variable Item", placeholder: "Find a variable", value: (_b = _this.searchTerm) !== null && _b !== void 0 ? _b : _this.currentlySelectedName, onChange: function (value) {
                        onChange(value);
                        (0, mobx_1.runInAction)(function () {
                            _this.searchTerm = value;
                        });
                    }, onFocus: function (event) {
                        onChange("");
                        onFocus(event);
                    }, onBlur: function (event) {
                        onBlur(event);
                        (0, mobx_1.runInAction)(function () {
                            _this.searchTerm = undefined;
                        });
                    }, labelHidden: inputLabelHidden, variant: inputVariant, size: inputSize })));
            } }));
    };
    var _a, _b;
    __decorate([
        (0, inversify_react_1.resolve)("quoteCurrencyFormatter"),
        __metadata("design:type", typeof (_a = typeof QuoteCurrencyFormatter_1.default !== "undefined" && QuoteCurrencyFormatter_1.default) === "function" ? _a : Object)
    ], VariablesCombobox.prototype, "quoteCurrencyFormatter", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("variableEditor"),
        __metadata("design:type", Object)
    ], VariablesCombobox.prototype, "variableEditor", void 0);
    __decorate([
        inversify_react_1.resolve,
        __metadata("design:type", typeof (_b = typeof VariableStore_1.default !== "undefined" && VariableStore_1.default) === "function" ? _b : Object)
    ], VariablesCombobox.prototype, "variableStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], VariablesCombobox.prototype, "searchTerm", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], VariablesCombobox.prototype, "currentlySelectedName", null);
    VariablesCombobox = __decorate([
        mobx_react_1.observer
    ], VariablesCombobox);
    return VariablesCombobox;
}(react_1.default.Component));
exports.default = VariablesCombobox;
